export const LOGIN = "/login";
export const REGISTER = "/register";
export const FORGOT_PASSWORD = "/forgot-password";
export const CLIENT_APPLY = "/client-apply";

export const PROFILE = "/profile";


export const OFFICES = "/offices";
export const OFFICE_HOME = "/office/:officeId/home"
export const OFFICE_SETTINGS = "/office/:officeId/settings";
export const OFFICE_REGISTER = "/office/new";
export const OFFICE_EDIT = "/office/:officeId";
export const OFFICE_MEMBERS = "/office/:officeId/members";

export const HIERARCHY_REGISTER = "/hierarchy/new";
export const HIERARCHY_EDIT = "/hierarchy/:hierarchyId/edit";

export const CASE_REGISTER = "/office/:officeId/case/new";
export const CASE_INFO = "/office/:officeId/case/:caseId";
export const ARCHIVED_CASES = "/archived-cases";

export const ACTIVITIES = "/activities";
export const ACTIVITY_DETAIL = "/activity/detail";
export const ATTENDANCE = "/attendance";
export const ATTENDANCE_RESULTS = "/attendance-results";
export const ATTENDANCE_REPORT = "/attendance-report";
export const ATTENDANCE_STUDENT_SCAN = "/attendance-student-scan";
export const ATTENDANCE_STUDENT_INFO = "/attendance-student-info"
export const CAPACITY = "/capacity";
export const CAPACITY_RESULTS = "/capacity-results";
export const INCIDENTS = "/incidents";
export const ONBOARDING = "/onboarding";
export const QR_PRE = "/qrInstructions";
export const QR_SCAN = "/qrScan";
export const LOCATION_DETAILS = "/location";
export const MAPA = "/mapa";